<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title">
          <a-icon class="margin-right" type="file-search" />Search
        </div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="closedstatus">Close Status</label>
                  <a-select placeholder="Ex: Not Closed ... " v-model="closedstatus" class="width-full" initialValue="0"
                    allowClear>
                    <a-select-option key="0" value="0">Not Closed</a-select-option>
                    <a-select-option key="1" value="1">Closed</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker placeholder="Select Date" v-model="searchDate" :format="getDefaultDateFormat"
                    allowClear />
                </div>
                <!-- <div class="m-form-item-wrapper">
                  <label for="kategori">Category</label>
                  <a-select
                    placeholder="Ex: Project ... "
                    v-model="kategori"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getCategoryPI"
                      :key="item.value"
                      :value="item.value"
                      >{{ item.text }}</a-select-option
                    >
                  </a-select>
                </div> -->
                <div class="m-form-item-wrapper">
                  <label for="matauang">Currency</label>
                  <a-select placeholder="Ex: IDR ..." v-model="matauang" class="width-full" initialValue allowClear>
                    <a-select-option v-for="item in getAllMataUang" :key="item.code" :value="item.code">{{ item.code }} -
                      {{ item.currency }}</a-select-option>
                  </a-select>
                </div>
                <!-- <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div> -->
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <a-spin tip="Your document is being processed, do not leave this page!" :spinning="loadings.tab">
        <DataList :tabbedTransactional="true" :loading="loading" title="PP List" :isMonitoring="true"
          :manifestLink="getManifestLink" :dataList="searching" :estimasi="false" :disabledCreateEditLink="true"
          :sisaSaldo="false" :informasi="true" :otherList="searching" dataListTitle="PP Technic"
          otherListTitle="PP Non Technic" />
      </a-spin>
    </a-col>
    <a-modal v-model="modalInfo" @ok="infoToggle" :footer="null">
      <span slot="title">&nbsp;Informasi</span>

      <ul class="m-list-wrapper bordered">
        <li>
          <div class="m-display-flex">
            <b>
              <span class="m-list-desc">Estimasi :</span>
            </b>
          </div>
          <div class="m-display-flex">
            <span class="m-list-desc">{{
              formatCurrency(informasi.mata_uang, informasi.estimated_value)
            }}</span>
          </div>
          <a-divider class="margin-small" />
          <div class="m-display-flex">
            <b>
              <span class="m-list-desc">Sisa Saldo :</span>
            </b>
          </div>
          <div class="m-display-flex">
            <span class="m-list-desc">{{
              formatCurrency(informasi.mata_uang, informasi.sisa_saldo)
            }}</span>
          </div>
        </li>
      </ul>
    </a-modal>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "monitoring_pp",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      kategori: undefined,
      searchDate: null,
      search: "",
      status: undefined,
      matauang: undefined,
      modalInfo: false,
      informasi: {
        estimated_value: 0,
        sisa_saldo: 0,
        mata_uang: null,
      },
      pageId: "",
      activeTab: "list",
      loadings: {
        tab: false,
      },
      closedstatus: "0",
    };
  },
  async mounted() {
    await this.fetchData();
    this.$store.dispatch("FETCH_ALL_MATA_UANG");
    Event.$on("handleInfo", this.infoToggle);
    Event.$on("callbackTab", this.clickTabed);
  },
  beforeDestroy() {
    Event.$off("callbackTab", this.clickTabed);
    Event.$off("handleInfo", this.infoToggle);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getCategoryPI",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAllMataUang",
      "getNavigation",
      "getNavigationId",
    ]),
    searching() {
      var self = this;
      let outputData = this.dataList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            (obj.search &&
              obj.search.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0) ||
            (obj.sisa_saldo &&
              this.formatCurrency(obj.mata_uang, obj.sisa_saldo)
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0)
        );
      }

      if (this.searchDate) {
        let filter = moment(this.searchDate).format(this.getStandartFormatDate);
        outputData = _.filter(outputData, (obj) => obj.tgl_buat === filter);
      }

      if (this.kategori) {
        outputData = _.filter(outputData, (item) => {
          return item.used_for === self.kategori;
        });
      }

      if (this.matauang) {
        outputData = _.filter(outputData, (item) => {
          return item.mata_uang === self.matauang;
        });
      }

      if (this.status) {
        if (this.status == "closed") {
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.closeStatus && obj.closeStatus.toLowerCase().indexOf("close") >= 0
          );
        } else if (this.status == "cancelled") {
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.cancelStatus && obj.cancelStatus.toLowerCase().indexOf("canceled") >= 0
          );
        } else {
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0 &&
              !(obj.closeStatus && obj.closeStatus.toLowerCase().indexOf("close") >= 0) &&
              !(obj.cancelStatus && obj.cancelStatus.toLowerCase().indexOf("canceled") >= 0)
          );
        }
      }

      return outputData;
    },
    getManifestLink() {
      if (localStorage.getItem("nvpn") === "/keuangan") {
        return "SpclPPManifestKeu";
      } else if (localStorage.getItem("nvpn") === "/pimpro") {
        return "SpclPPManifestPimpro";
      } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
        return "SpclPPManifestAL";
      } else if (localStorage.getItem("nvpn") === "/purchasing") {
        return "SpclPPManifest_purchase";
      } else if (localStorage.getItem("nvpn") === "/direktur") {
        return "SpclPPManifestDir";
      } else if (localStorage.getItem("nvpn") === "/ga") {
        return "SpclPPManifestGA";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        return "SpclPPManifestAcc";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclPPManifestVpf";
      } else {
        return "SpclPPManifestOPC";
      }
    },
  },
  watch: {
    closedstatus() {
      if (this.closedstatus) {
        this.loadings.tab = true;
        this.dataList = [];
        this.fetchData();
        this.resetFilter();
      }
    }
  },
  methods: {
    moment,
    async fetchData() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/pp",
        params: {
          id: localStorage.getItem("nvky"),
          tlc: this.getAuth.username,
          close_sts: this.closedstatus,
          used_for: this.activeTab == 'list' ? "1" : "2",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          response.data.data.forEach((data) => {
            this.dataList.push({
              title: data.no_pp + " | " + data.tlc_pembuat,
              search:
                data.no_pp +
                " " +
                data.deskripsi +
                " " +
                data.estimated_value +
                " " +
                data.total_pemakaian +
                " " +
                data.tlc_pembuat,
              subtitle: data.deskripsi,
              tgl_buat: data.tgl_buat,
              kategori: data.kategori,
              mata_uang: data.mata_uang,
              timeline: JSON.parse(data.status_app),
              subdesc: [
                [
                  {
                    label: "Create Date",
                    value: moment(data.tgl_buat).format(this.getDefaultDateFormat),
                  },
                ],
                [
                  {
                    label: "Estimated Price",
                    value: this.formatCurrency(
                      data.mata_uang,
                      data.estimated_value
                    ),
                  },
                ],
                [
                  {
                    label: "Total Usage",
                    value: this.formatCurrency(
                      data.mata_uang,
                      data.total_pemakaian
                    ),
                  },
                ],
                [
                  {
                    label: "Remaining Balance",
                    value: this.formatCurrency(data.mata_uang, data.sisa_saldo),
                  },
                ],
              ],
              status: data.status,
              id: data.id_pp,
              used_for: data.used_for,
              unread: data.unread == "1" ? true : false,
              closeStatus: data.close_sts == "1" ? "Close" : "",
              cancelStatus: data.cancel_sts
                ? data.cancel_sts == 1
                  ? "Canceled"
                  : null
                : null,
              canceled_Status: data.canceled_status
                ? data.canceled_status == "1"
                  ? "Canceled"
                  : null
                : null,
              status_keuangan: (['1', '2']).indexOf(data.used_for) >= 0 ? data.status_keuangan : null,
              endStatus: data.close_sts == "1" ? "Closed" : null
            });
          });
          this.loading = false;
          this.loadings.tab = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
            this.loading = false;
            this.loadings.tab = false;
          } else {
            this.loading = false;
            this.loadings.tab = false;
            this.displayMessage("empty-db");
          }
        });
    },
    infoToggle(item) {
      this.informasi = {
        estimated_value: item.estimated_value,
        sisa_saldo: item.sisa_saldo,
        mata_uang: item.mata_uang,
      };
      this.modalInfo = !this.modalInfo;
    },
    resetFilter() {
      this.search = null;
      this.searchDate = null;
      this.kategori = null;
      this.matauang = null;
      this.status = null;
    },
    clickTabed(val) {
      this.activeTab = val;
      this.loadings.tab = true;
      this.dataList = [];
      this.fetchData();
      this.resetFilter();
    }
  },
};
</script>

<style lang="less"></style>